var SDK_VERSION = '7.9.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
